<script setup lang="ts">
import qs from "qs";

const $route = useRoute();
const currentPage = ref(1);

const query = qs.stringify(
  {
    fields: ["title", "slug"],
    populate: {
      image: {
        fields: ["url", "name"],
      },
    },
    filters: {
      author: {
        slug: $route.params.slug,
      },
    },
    sort: "createdAt:desc",
  },
  {
    encodeValuesOnly: true,
  },
);
const { data: posts, status } = useCustomFetch(
  `/api/strapi-full/education-posts?${query}`,
  {
    query: {
      "pagination[page]": currentPage,
      "pagination[pageSize]": 21,
    },
    watch: [currentPage],
  },
);

const queryAuthor = qs.stringify(
  {
    fields: ["full_name", "slug", "bio"],
    populate: {
      seo: "*",
      avatar: {
        fields: ["url", "name"],
      },
    },
    filters: {
      slug: { $eq: $route.params.slug },
    },
  },
  {
    encodeValuesOnly: true,
  },
);

const { data: authorData } = useCustomFetch(
  `/api/strapi-full/authors?${queryAuthor}`,
);
const data = computed(() => authorData?.value?.data?.[0]?.attributes);

const { data: translation } = useCustomFetch("/api/strapi/translation");

const onClickHandler = async (page: number) => {
  currentPage.value = page;
};

// Watch for changes to data and scroll to top
watch(posts, () => {
  window.scrollTo(0, 0);
});
</script>

<template>
  <FullScreenLoader v-if="status === 'pending'" />
  <section v-if="data" class="main-container">
    <SeoMeta v-if="data?.data?.seo" v-bind="data?.data?.seo" />
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <img
            :src="$getStrapiImageSrc(data?.avatar)"
            class="object-fit-cover mx-auto d-block author-img"
            :alt="data?.full_name"
          />
          <h2 class="text-center">{{ data?.full_name }}</h2>
          <div
            class="author-about fz-16 styled-content"
            v-html="$mdRenderer.render(data?.bio)"
          ></div>
        </div>
      </div>
      <h2>{{ translation?.authors_page }}</h2>

      <div v-if="posts?.data?.length === 0" class="col-md-12">
        <h2 class="text-center my-4">{{ translation?.nothing_to_show }}</h2>
      </div>

      <div class="row">
        <div
          v-for="post in posts?.data"
          class="col-xs-12 col-md-6 col-lg-4 mt-20"
        >
          <EducationCategoryCard
            v-if="post"
            :key="post.id"
            :slug="post.attributes?.slug"
            :title="post.attributes?.title"
            :image="post.attributes?.image"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <vue-awesome-paginate
            :total-items="posts?.meta?.pagination?.total"
            :items-per-page="posts?.meta?.pagination?.pageSize"
            :max-pages-shown="5"
            v-model="currentPage"
            @click="onClickHandler"
          />
        </div>
      </div>
    </div>
  </section>

  <JoinCta />
</template>
